<template>
  <div v-show="show">
    <div class="container-cats">
      <a href="javascript:" class="text-secondary text-decoration-none cat"
         :class="{'selected': category === index}"
         v-for="(c, index) in categories"
         @click="selCategory(c, index)">
        <i :class="c.icon"></i>
      </a>
    </div>
    <div class="container-emojis border-bottom">
      <a href="javascript:" class="text-decoration-none sel" v-for="e in emojis"
         @click="selEmoji(e)">
        {{e.emoji}}
      </a>
    </div>
  </div>
</template>

<script>
import json from '../db/emoji.json'
export default {
  name: "ListEmojis",
  data() {
    return {
      show: false,
      json: json,
      emojis: [],
      category: '',
      categories: [
        { name: 'Smileys & Emotion', icon: 'far fa-smile' },
        { name: 'People & Body', icon: 'fas fa-thumbs-up' },
        { name: 'Animals & Nature', icon: 'fas fa-tree' },
        { name: 'Food & Drink', icon: 'fas fa-coffee' },
        { name: 'Travel & Places', icon: 'fas fa-car' },
        { name: 'Activities', icon: 'fas fa-futbol' },
        { name: 'Objects', icon: 'fas fa-wrench' },
        { name: 'Symbols', icon: 'far fa-heart' },
        { name: 'Flags', icon: 'far fa-flag' }
      ]
    }
  },

  methods: {
    selCategory(c, index) {
      this.category = index;
      this.emojis = this.json.filter(j => j.category === c.name)
    },

    selEmoji(e) {
      this.$emit('addEmoji', e.emoji)
    }
  },

  mounted() {
    this.selCategory(this.categories[0], 0);
  },

  created() {
    this.$parent.$on('toggleEmoji', (close) => {
      this.show = close ? false : !this.show;
    });
  }
}
</script>

<style scoped>
.container-cats {
  display: flex;
  justify-content: space-between;
}
.cat {
  display: block;
  width: 100%;
  height: 32px;
  font-size: 18px;
  text-align: center;
}
.cat.selected {
  border-bottom: 2px solid var(--success);
  color: var(--success)!important;
}
.sel {
  font-size: 20px;
  width: 32px;
  height: 32px;
}
.container-emojis {
  height: 30vh;
  overflow: auto;
  padding: 8px 0;
  margin-bottom: 12px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
}
</style>